import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { PublicApiService } from '../shared/services/public-api.service';
import { AvailableHour, AvailableHours } from '../shared/interfaces/available-hours.model';
import * as moment from 'moment';
import { PublicService } from '../shared/services/public.service';
import { PageDataScheduleTypes } from '../shared/interfaces/page-data.enum';
import { filter } from 'rxjs/operators';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-available-hours',
  templateUrl: './available-hours.component.html',
  styleUrls: ['./available-hours.component.scss']
})
export class AvailableHoursComponent implements OnInit  {

  private subscription!: Subscription;
  
  public availableHoursData!: AvailableHours[];
  public selectedAvailableHour!: AvailableHour | undefined;
  public selectedPeriodMonth!: any;
  public limitDays: number = 4;
  public selectedDate!: any;

  public periodMonthsData: any[] = [];

  constructor(
    private router: Router,
    private datePipe: DatePipe,
    private publicApiService: PublicApiService,
    private publicService: PublicService,
    private activatedRoute: ActivatedRoute
  ) {
    this.subscription = new Subscription();
  }

  ngOnInit(): void {
    this.createPeriodsMonth();
    this.selectedPeriodMonth = this.periodMonthsData[0];
    this.filterMonthChanged();
  }

  private createPeriodsMonth(): void {
    this.periodMonthsData.push(this.createPeriodFilter());
    this.periodMonthsData.push(this.createPeriodFilter(1));
    this.periodMonthsData.push(this.createPeriodFilter(2));
  }

  private createPeriodFilter(addMonth?: number): any {
    let date: any = moment();
    let start_date: string = date.format('YYYY-MM-DD');
    let end_date: string = date.endOf('month').format('YYYY-MM-DD');

    if (addMonth) {
      date.add(addMonth, 'months')
      start_date = date.startOf('month').format('YYYY-MM-DD');
      end_date = date.endOf('month').format('YYYY-MM-DD');
    }
    return { start_date, end_date };
  }

  private getAvailableHoursByPeriod() {
    this.subscription.add(
      this.publicApiService.getAvailableHoursByDentist(
        this.selectedPeriodMonth.start_date, 
        this.selectedPeriodMonth.end_date)
          .pipe(filter(x => !!x || (x as []).length))
          .subscribe(x => {
            this.availableHoursData = x
              .map(x => this.mapOnlyNextAvailableTimes(x))
              .map(x => this.mapCreatePeriodsForEachDay(x))
              .filter(x => x.available_hours.length)
          })
    );
  }

  private mapOnlyNextAvailableTimes(availableHours: AvailableHours): AvailableHours {
    return {
      ...availableHours,
      available_hours: availableHours.available_hours
        .filter(x => {
          const startTime = this.datePipe.transform(x.start_time, 'yyyy-MM-dd HH:mm', '+000');
          return moment(startTime) > moment();
        })
    }
  };

  private mapCreatePeriodsForEachDay(availableHours: AvailableHours): AvailableHours {
    return {
      ...availableHours,
      periods: [
        availableHours.available_hours.filter(x => 
          Number(moment(x.start_time).utc().format("HH")) < 12
        ),
        availableHours.available_hours.filter(x => 
          Number(moment(x.start_time).utc().format("HH")) >= 12
        )
      ]
    }
  }

  private navigate(timeout: number = 200): void {
    setTimeout(() => {
      this.router.navigate(['summary'], { relativeTo: this.activatedRoute})
    }, timeout);
  }

  getBackRouterLink(): string {
    return this.publicService.getBackRouterLinkToDentist();
  }

  isSelected(date: string, start_time: string): boolean {
    if (!this.selectedAvailableHour) {
      return false;
    } 
    return this.selectedAvailableHour.start_time === start_time
  }

  onAvailableHourClick(hour: AvailableHour): void {
    this.selectedAvailableHour = hour;
    this.publicService.setPublicScheduleSelectedData(
      PageDataScheduleTypes.AVAILABLE_HOURS_SCHEDULE_DATA,
      this.selectedAvailableHour
    );
    this.navigate();
  }

  onDateCollapseClick(date: AvailableHours) {
    date.showMore = !Boolean(date.showMore);
  }

  onMoreDays() {
    this.limitDays = this.limitDays + 4;
  }

  showMoreDaysButton(): boolean {
    return this.availableHoursData.length > this.limitDays;
  }

  filterMonthChanged(): void {
    this.selectedAvailableHour = undefined;
    this.getAvailableHoursByPeriod();
  }

  compareObjects(o1: any, o2: any) {
    if (o1.start_date === o2.start_date) {
      return true;
    }
    return false
  }
}
